/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360BusinessLogicCategoriesInventoryListItem } from './open360BusinessLogicCategoriesInventoryListItem';
import { Open360BusinessLogicPlacesOffersAudienceOfferAudienceModel } from './open360BusinessLogicPlacesOffersAudienceOfferAudienceModel';
import { Open360BusinessLogicRetailersCampaignsBECampaignKeyword } from './open360BusinessLogicRetailersCampaignsBECampaignKeyword';
import { Open360BusinessLogicRetailersCampaignsBECampaignProductLink } from './open360BusinessLogicRetailersCampaignsBECampaignProductLink';
import { Open360BusinessLogicRetailersInformationCardsNfcStickerItemModel } from './open360BusinessLogicRetailersInformationCardsNfcStickerItemModel';
import { Open360ShopperApiContractV18VideosVideoItemResourceModel } from './open360ShopperApiContractV18VideosVideoItemResourceModel';
import {ICampaignInformationCardLink} from '../campaigns/models'


export interface Open360BusinessLogicRetailersCampaignsBECampaign {
    Name: string;
    PushNotification: string;
    StartDate?: Date;
    EndDate?: Date;
    AlertDate?: Date;
    DailyStartTime?: string;
    DailyEndTime?: string;
    /**
     * 1 = Sunday, 2 = Monday, 4 = Tuesday, 8 = Wednesday, 16 = Thursday, 32 = Friday, 64 = Saturday
     */
    DaysOfWeek?: Open360BusinessLogicRetailersCampaignsBECampaign.DaysOfWeekEnum;
    NfcStickers?: Array<Open360BusinessLogicRetailersInformationCardsNfcStickerItemModel>;
    /**
     * 1 = Draft, 2 = AdSubmission, 3 = QualityControl, 4 = Active, 5 = Archived
     */
    EntityStatus?: Open360BusinessLogicRetailersCampaignsBECampaign.EntityStatusEnum;
    ImageID?: number;
    VideoID?: number;
    /**
     * 1 = Html, 2 = Image, 3 = Video, 4 = Gif
     */
    ContentType?: Open360BusinessLogicRetailersCampaignsBECampaign.ContentTypeEnum;
    Video?: Open360ShopperApiContractV18VideosVideoItemResourceModel;
    /**
     * 1 = Added, 2 = Uploaded, 3 = Processing, 4 = ProcessingError, 5 = Processed
     */
    VideoStatus?: Open360BusinessLogicRetailersCampaignsBECampaign.VideoStatusEnum;
    Description?: string;
    Audience?: Open360BusinessLogicPlacesOffersAudienceOfferAudienceModel;
    GeoTargeting?: boolean;
    SimpleAudienceMode?: boolean;
    JispExclusive?: boolean;
    /**
     * 1 = Running, 2 = Archived, 3 = Completed, 4 = Error, 5 = Disabled, 6 = Warning, 7 = Scheduled, 8 = Draft, 9 = AdSubmission, 10 = QualityControl, 13 = Undefined, 14 = VideoProcessing, 15 = VideoProcessingError
     */
    Status?: Open360BusinessLogicRetailersCampaignsBECampaign.StatusEnum;
    StatusMessage?: string;
    CreateDate?: Date;
    CampaignProductLinks?: Array<Open360BusinessLogicRetailersCampaignsBECampaignProductLink>;
    CampaignInformationCardLinks?: ICampaignInformationCardLink[];
    Keywords?: Array<Open360BusinessLogicRetailersCampaignsBECampaignKeyword>;
    /**
     * 1 = Offer, 2 = Promotion, 3 = Advert, 4 = FlashSale, 5 = Event, 6 = Voucher, 8 = SpecialEvent
     */
    Type?: Open360BusinessLogicRetailersCampaignsBECampaign.TypeEnum;
    IsExclusiveOffer?: boolean;
}
export namespace Open360BusinessLogicRetailersCampaignsBECampaign {
    export type DaysOfWeekEnum = 1 | 2 | 4 | 8 | 16 | 32 | 64;
    export const DaysOfWeekEnum = {
        NUMBER_1: 1 as DaysOfWeekEnum,
        NUMBER_2: 2 as DaysOfWeekEnum,
        NUMBER_4: 4 as DaysOfWeekEnum,
        NUMBER_8: 8 as DaysOfWeekEnum,
        NUMBER_16: 16 as DaysOfWeekEnum,
        NUMBER_32: 32 as DaysOfWeekEnum,
        NUMBER_64: 64 as DaysOfWeekEnum
    }
    export type EntityStatusEnum = 1 | 2 | 3 | 4 | 5;
    export const EntityStatusEnum = {
        NUMBER_1: 1 as EntityStatusEnum,
        NUMBER_2: 2 as EntityStatusEnum,
        NUMBER_3: 3 as EntityStatusEnum,
        NUMBER_4: 4 as EntityStatusEnum,
        NUMBER_5: 5 as EntityStatusEnum
    }
    export type ContentTypeEnum = 1 | 2 | 3 | 4;
    export const ContentTypeEnum = {
        NUMBER_1: 1 as ContentTypeEnum,
        NUMBER_2: 2 as ContentTypeEnum,
        NUMBER_3: 3 as ContentTypeEnum,
        NUMBER_4: 4 as ContentTypeEnum
    }
    export type VideoStatusEnum = 1 | 2 | 3 | 4 | 5;
    export const VideoStatusEnum = {
        NUMBER_1: 1 as VideoStatusEnum,
        NUMBER_2: 2 as VideoStatusEnum,
        NUMBER_3: 3 as VideoStatusEnum,
        NUMBER_4: 4 as VideoStatusEnum,
        NUMBER_5: 5 as VideoStatusEnum
    }
    export type StatusEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 13 | 14 | 15;
    export const StatusEnum = {
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum,
        NUMBER_3: 3 as StatusEnum,
        NUMBER_4: 4 as StatusEnum,
        NUMBER_5: 5 as StatusEnum,
        NUMBER_6: 6 as StatusEnum,
        NUMBER_7: 7 as StatusEnum,
        NUMBER_8: 8 as StatusEnum,
        NUMBER_9: 9 as StatusEnum,
        NUMBER_10: 10 as StatusEnum,
        NUMBER_13: 13 as StatusEnum,
        NUMBER_14: 14 as StatusEnum,
        NUMBER_15: 15 as StatusEnum
    }
    export type TypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 8;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_4: 4 as TypeEnum,
        NUMBER_5: 5 as TypeEnum,
        NUMBER_6: 6 as TypeEnum,
        NUMBER_8: 8 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersCampaignsBECampaign.ts